import React, { Component } from 'react';

import moment from 'moment';

import SettingsCardHeader from './SettingsCardHeader';
import GoalResultItem from './GoalResultItem';

export default class GoalsViewResults extends Component {

    constructor(props) {
        super(props);

        this.defaultProps = {}

        this.state = {

        }

        this.generateGoalResultItems = this.generateGoalResultItems.bind(this);
    }

    componentDidMount() {

    }

    componentWillReceiveProps() {

    }

    componentWillUnmount() {

    }

    generateGoalResultItems() {
        let griJsx = [];
        let identity = this.props.identity;
        let blastData = identity.blastData;

        let organizedGoalItems = Object.values(blastData.reduce((r, e) => {

            if (parseInt(moment(identity.timeFrame != 'Day' ? e.calEnd.substring(0, e.calEnd.length - 1) : e.calStart.substring(0, e.calEnd.length - 1)).format("YYYYMMDD")) === e.dateIndex) {
                let key = identity.timeFrame != 'Day' ? e.calEnd : e.calStart;
                if (!r[key]) {
                    r[key] = {
                        type: e.type,
                        isOver: parseInt(moment().format("YYYYMMDD")) > e.dateIndex,
                        dateIndex: e.dateIndex,
                        dateRangeString: identity.timeFarme != 'Day' ? (moment(e.calStart).format("MM/DD/YYYY") + ' - ' + moment(e.calEnd).format("MM/DD/YYYY")) : moment(e.calStart).format("MM/DD/YYYY"),
                        actualVal: e.cyValue,
                        goalVal: identity.type === '#' ? identity.value : (identity.useUnder ? (e.lyValue * ((100.0 - identity.value) / 100.0)) : (e.lyValue * ((100.0 + identity.value) / 100.0))),
                    }
                    let tempMath = r[key].goalVal === 0 ? 1 : (r[key].actualVal / r[key].goalVal);
                    if (tempMath > 1) {
                        tempMath = 1;
                    } else if (tempMath < 0) {
                        tempMath = 0;
                    }
                    r[key].fillPerc = (tempMath * 100.0).toFixed(2);
                }
            }

            return r;
        }, {}));

        organizedGoalItems = _.sortBy(organizedGoalItems, (obj) => { return obj.dateIndex });

        organizedGoalItems.forEach((goalItem) => {
            griJsx.push((
                <GoalResultItem
                    identity={goalItem}
                    mainGoal={identity}
                />
            ))
        });

        return griJsx;
    }

    render() {

        if (this.props.identity === undefined || this.props.identity === null) {
            return (
                <div className={this.props.className} style={this.props.style}>
                    <div className={"settings-central-regular-card-container"}>
                    </div>
                </div>
            );
        }

        let resultItems = this.generateGoalResultItems();

        return (
            <div className={this.props.className} style={this.props.style}>
                <div className={"settings-central-regular-card-container"} style={{ lineHeight: 1 }}>
                    <SettingsCardHeader
                        title={this.props.identity.name}
                        subtitle={this.props.identity.description}
                    />
                    {resultItems}
                </div>
            </div>
        );
    }
}